<div>

    <div style="display: flex; align-items: center">
        <div class="toolbar_item" style="flex-grow: 1">
            <p-fileUpload
                    name="fileTemplate"
                    chooseIcon="pi pi-upload"
                    cancelIcon="pi pi-times"
                    [maxFileSize]="10000000"
                    [showCancelButton]="false"
                    [showUploadButton]="false"
                    [files]="innerDataFileReference"
                    (onRemove)="onDataFileDeselected()"
                    (onSelect)="onDataFileSelected($event.files)">
                <ng-template pTemplate="file"></ng-template>
                <ng-template pTemplate="content" let-files let-uploadedFiles="uploadedFiles">
                    <div *ngFor="let file of files" style="display: flex">
                        <div style="flex-grow: 1">
                            <div style="max-width: 30em; overflow: hidden; text-overflow: ellipsis;">{{ file.name }}</div>
                            <div>({{ file.size / 1000 }}kb)</div>
                        </div>
                        <div>
                            <p-button severity="danger" icon="pi pi-times" (click)="onDataFileDeselected()"></p-button>
                        </div>
                    </div>
                    <div *ngIf="files.length == 0">
                        nessun file selezionato
                    </div>
                </ng-template>
            </p-fileUpload>
        </div>
        <div style="flex-grow: 1; margin-left: 1em; max-height: 30vh; overflow-y: auto" [ngSwitch]="oplist != null && oplist.length > 0">
            <div *ngSwitchCase="false" style="text-align: center">
                nessuna operazione caricata
            </div>
            <div *ngSwitchCase="true">

                <p-table [value]="oplist">

                    <ng-template pTemplate="header">
                        <tr>
                            <th>operazione</th>
                            <th>magazzino</th>
                            <th>dispositivo</th>
                            <th>quantità</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row>
                        <tr>
                            <td>{{row.opid}}</td>
                            <td>{{row.mag.codice}}</td>
                            <td>{{row.mat.nmu}}</td>
                            <td>{{row.qt}}</td>
                        </tr>
                    </ng-template>
                </p-table>



            </div>


        </div>

    </div>
    <p-divider type="solid"></p-divider>

    <div style="display: flex; align-items: center">
        <div style="flex-grow: 1">

            ATTENZIONE: le operazioni estratte nella tabella sono finali e vengono attuate automaticamente alla conferma.<br>
            Tutte le operazioni con codice operazione già usato in passato verranno ignorate.<br>
            L'ordine di esecuzione delle operazioni potrebbe non corrispondere alla sequenza degli id nel file.

        </div>
        <div class="dialog_controls">

            <p-button icon="pi pi-times" label="Annulla" class="p-button-text mr-1 row_button" (click)="onActivityCompleted(false)"></p-button>
            <p-button icon="pi pi-check" label="Conferma" class="p-button-text ml-100 row_button" styleClass="p-button-success" (click)="onActivityCompleted(true)" [disabled]="(!oplist) || oplist.length == 0"></p-button>
        </div>


    </div>

</div>